<template>
  <div>
    <data-table ref="dataTable" :option="option"> </data-table>
  </div>
</template>

<script>
import { DataTable } from "@/components/dataTable";

export default {
  name: "channelManage_product",
  components: { DataTable },
  props: {
    productId: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    return {};
  },
  created() {
    this.option = {
      form: {
        colnum: 1,
        width: 500,
        title: "规则",
        add: {
          submitApi: "Product_AddRule",
          onOpenAfter: () => {
            return { ValidStatus: "1", ProductId: this.productId };
          }
        },
        edit: {
          infoApi: "Product_GetProductRule",
          submitApi: "Product_EditRule"
        },
        del: { submitApi: "Product_DelRule" },
        content: [
          {
            label: false,
            name: "ProductId",
            type: "hidden"
          },
          {
            label: "开始日期",
            name: "StartDate",
            type: "date",
            option: {
              rules: [{ required: true, message: "请填写开始日期！" }]
            }
          },
          {
            label: "结束日期",
            name: "EndDate",
            type: "date",
            option: {
              rules: [{ required: true, message: "请填写结束日期！" }]
            }
          },
          {
            label: "可售房数",
            name: "RoomCount",
            type: "number", //计数器
            min: 0,
            option: {
              rules: [{ required: true, message: "请填写可售房数！" }]
            }
          },
          {
            label: "状态",
            name: "ValidStatus",
            placeholder: "请选择",
            option: {
              rules: [{ required: true, message: "请选择状态！" }]
            },
            type: "select",
            valueField: "value",
            textField: "text",
            data: [
              {
                value: "0",
                text: "禁用"
              },
              {
                value: "1",
                text: "启用"
              }
            ]
          }
        ]
      },
      grid: {
        api: "Product_GetProductRulePageList",
        params: { ProductId: this.productId },
        props: {
          scroll: { x: false, y: 430 }
        },
        columns: [
          {
            title: "序号",
            width: "50px",
            align: "center",
            type: "indexcolumn"
          },
          {
            title: "开始日期",
            width: 150,
            dataIndex: "StartDate"
          },
          {
            title: "结束日期",
            width: 150,
            dataIndex: "EndDate"
          },
          {
            title: "可售房数",
            width: 150,
            dataIndex: "RoomCount"
          },
          {
            title: "状态",
            width: 150,
            dataIndex: "ValidStatus",
            customRender: text => {
              if (text) {
                return <a-badge status="success" text="启用" />;
              } else {
                return <a-badge status="error" text="禁用" />;
              }
            }
          },
          {
            title: "操作",
            dataIndex: "Id",
            key: "action",
            scopedSlots: { customRender: "rowAction" }
          }
        ]
      }
    };
  },
  mounted() {},
  methods: {},
  computed: {},
  watch: {}
};
</script>

<style lang="less" scoped></style>
